import React, { useState } from "react";
import { withRouter } from "react-router";
import { useMutation } from "@apollo/react-hooks";
import { Button } from "components/common";
import { CREATE_ISSUING_ACCOUNT_QUERY } from "./gql";

const NewUser = () => {
  const [createConnectedAccount] = useMutation(CREATE_ISSUING_ACCOUNT_QUERY);
  const [loading, setLoading] = useState(false);
  const [redirecting, setRedirecting] = useState(false);
  const [error, setError] = useState(null);

  const onClick = async () => {
    try {
      setLoading(true);
      const response = await createConnectedAccount();

      if (response.errors) {
        console.error(response.errors);
        setError(response.errors[0].message);
      }

      const { onboardingLink: newLink } =
        response?.data?.createUserIssuingAccount || {};

      if (newLink) {
        setRedirecting(true);
        window.location.assign(newLink);
      } else {
        setError("Something went wrong, please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center text-center">
      <div className="text-3xl">Start Your Application</div>
      <div className="mt-4 text-lg">
        <span>Open a business card with Tomo!</span>
      </div>
      {error && <div className="mt-6 text-red-500">{error}</div>}
      <div className="mt-6">
        <Button disabled={loading || redirecting} onClick={onClick}>
          <span>Start Application</span>
          {loading && (
            <i className="ml-2 fa-solid fa-circle-notch fa-spin text-white" />
          )}
        </Button>
      </div>
    </div>
  );
};

const OnboardingUser = ({ onboardingLink }) => {
  const [redirecting, setRedirecting] = React.useState(false);

  const onClick = async () => {
    if (!onboardingLink) {
      return;
    }
    setRedirecting(true);
    window.location.assign(onboardingLink);
  };

  return (
    <div className="flex flex-col items-center justify-center text-center">
      <div className="text-3xl">Finish Your Application</div>
      <div className="mt-4 text-lg">
        <span>
          Resume your application and/or add necessary information to continue
        </span>
      </div>
      <div className="mt-6">
        <Button disabled={redirecting} onClick={onClick}>
          {redirecting ? "Resuming" : "Resume"} Application
          {redirecting && (
            <i className="ml-2 fa-solid fa-circle-notch fa-spin text-white" />
          )}
        </Button>
      </div>
    </div>
  );
};

const IssuingOnboarding = ({ userIssuingStatus }) => {
  const { onboardingLink } = userIssuingStatus;
  return (
    <div className="flex flex-col items-center justify-center">
      <div className="max-w-xl">
        {onboardingLink ? (
          <OnboardingUser onboardingLink={onboardingLink} />
        ) : (
          <NewUser />
        )}
      </div>
    </div>
  );
};

export default withRouter(IssuingOnboarding);
